import { createContext, useContext } from "react";

export type ColumnContextProps = {
  id: string;
  depth: number;
};

export const ColumnContext = createContext<ColumnContextProps | null>(null);

export function useColumn() {
  const context = useContext(ColumnContext);
  if (context) return context;
  throw new Error("useColumn must be used within column");
}
